import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import '@radix-ui/themes/styles.css';
import './styles/globals.css';
// import './index.css';
// import "./main.css"
// import 'mui-player/dist/mui-player.min.css';
import './main.css';
import 'katex/dist/katex.min.css';
import 'github-markdown-css/github-markdown-light.css';

createRoot(document.getElementById('root')!).render(<App />);
